export const MEMBER_ROLES = {
  editor: {
    value: 'editor',
    label: 'Editor',
    description: 'Può modificare checklist, spese, note e itinerario',
  },
  journal: {
    value: 'journal',
    label: 'Viewer',
    description: 'Solo lettura: diario personale, senza spese né modifiche al viaggio',
  },
};

export function memberRoleLabel(role) {
  return MEMBER_ROLES[role]?.label ?? 'Editor';
}

export function renderMemberRoleSelect(name, selected = 'editor', { disabled = false, memberUserId = null, compact = false } = {}) {
  const options = Object.values(MEMBER_ROLES)
    .map((r) => {
      const label = compact ? r.label : `${r.label} — ${r.description}`;
      return `<option value="${r.value}" title="${r.description}"${r.value === selected ? ' selected' : ''}>${label}</option>`;
    })
    .join('');

  const dataAttr = memberUserId ? ` data-member-role="${memberUserId}"` : '';

  return `
    <select class="field-input field-select trip-group__role-select" name="${name}"${dataAttr} ${disabled ? 'disabled' : ''}>
      ${options}
    </select>
  `;
}
